export var HEADER_HORIZONTAL_PADDING = 80;
export var MEDIUM_LOGO_SIZE = 'medium';